module.exports = __webpack_public_path__ + "img/mindful_floorplan.7b174504.svg";